module.exports = __webpack_public_path__ + "c0488ea683bca182c9b98d7305a9e072.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_l_30.mp3
// module id = 446
// module chunks = 0